import React from 'react';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import uploadStudentDetailsService from './uploadStudentDetailsService';
import displayRazorpay from './utils/PaymentGateway';
import Step6Success from './Step6Success';
import { Button } from '@mui/material';
import { Box } from '@mui/system';

const mock = [
 
  {
    name: 'Student Name',
    Subject: '',  
  },
  {
    name: 'Father Name',
    Subject: '',
  },
  {
    name: 'Mother Name',
    Subject: ' ',
  },
  {
    name: 'For Class',
    Subject: '',
  },
  {
    name: 'Application No',
    Subject: '', 
  },
  
  
];

const StepFivePayment = ({initialState, secondState, thirdState, handleCurrentStep}) => {

  const [retryMsg, setRetryMsg] = React.useState(false)

  mock[0].Subject = initialState.fullName;
  mock[1].Subject = secondState.fatherName;
  mock[2].Subject = secondState.motherName;
  mock[3].Subject = initialState.class;

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  React.useEffect(() => {
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  });

  const callback = (response) => {
    console.log('resultant', response);
    if(response) {
      const data = {...initialState, ...secondState}
      uploadStudentDetailsService(data, '5', true, response);
      handleCurrentStep(6);
    } else {
      alert('payment is failed');
      setRetryMsg(true);
    }
  };

  const handlePayment = async() => {
    setRetryMsg(false);
    const result = await displayRazorpay(callback);
    console.log('result', result);
  };

  return (
<>
    <Typography variant={'h5'} fontWeight={700} gutterBottom>
          <br />Application Fee Payment For Academic Year 2022-23
    </Typography>
  <TableContainer component={Paper}>
    <Table sx={{ minWidth: 750 }} aria-label="simple table">
      <TableHead sx={{ bgcolor: 'alternate.dark' }}>
        <TableRow>
          <TableCell>
            <Typography
              variant={'caption'}
              fontWeight={700}
              sx={{ textTransform: 'uppercase' }}
            >
            
            </Typography>
          </TableCell>
          <TableCell>
            <Typography
              variant={'caption'}
              fontWeight={700}
              sx={{ textTransform: 'uppercase' }}
            >
            
            </Typography>
          </TableCell>
          <TableCell>
            {/* <Typography
              variant={'caption'}
              fontWeight={700}
              sx={{ textTransform: 'uppercase' }}
            >
              Title
            </Typography> */}
          </TableCell>   
          <TableCell>
            {/* <Typography
              variant={'caption'}
              fontWeight={700}
              sx={{ textTransform: 'uppercase' }}
            >
              Status
            </Typography> */}
          </TableCell> 
          <TableCell>
            {/* <Typography
              variant={'caption'}
              fontWeight={700}
              sx={{ textTransform: 'uppercase' }}
            >
              Role
            </Typography> */}
          </TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {mock.map((item, i) => (
          <TableRow
            key={i}
            sx={{
              '&:last-child td, &:last-child th': { border: 0 },
              '&:nth-of-type(2n)': { bgcolor: 'alternate.main' },
            }}
          >
            <TableCell component="th" scope="row">
              <Typography variant={'subtitle2'} fontWeight={700}>
                {item.name}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography color={'text.secondary'} variant={'subtitle2'}>
                {item.Subject}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography color={'text.secondary'} variant={'subtitle2'}>
                {item.title}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant={'caption'}
                fontWeight={700}
              >
                {item.status}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography color={'text.secondary'} variant={'subtitle2'}>
                {item.role}
              </Typography>
            </TableCell>
            <TableCell>
              {/* <Typography
                color={'primary'}
                variant={'subtitle2'}
                fontWeight={700}
                sx={{ cursor: 'pointer' }}
              >
                Edit
              </Typography> */}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>

    <article className="card">
      <Box
        component={Button}
        variant="contained"
        bgcolor="primary"
        size="large"
        marginTop={{ xs: 6, sm: 6 }}
        marginLeft={{ sm: 50}}
        onClick={handlePayment}
        className="course-payment-button"
      >
        Payment 
      </Box>
      {retryMsg && <div style={{ color: 'red'}}>---Please retry Payment---</div> }
    </article>
    </>
  );
};

export default StepFivePayment;
